import { IOAuthProviderConfig } from "../../@types/OAuth";
import { dexcomService } from "../../services/dexcomService";
import { OAuthCallbackPage } from "../OAuthCallback";

const DEXCOM_CONFIG: IOAuthProviderConfig = {
  providerName: "Dexcom",
  completeAuthorization: dexcomService.completeAuthorization,
};

export function DexcomCallbackPage() {
  return <OAuthCallbackPage config={DEXCOM_CONFIG} />;
}
